import React from 'react';
import PropTypes from 'prop-types';

const SparklyEye = ({ x }) => (
  <g>
    <ellipse cx={x} cy="1" rx="5.5" ry="7.5" fill="#294d34" />
    <circle cx={x - 1.5} cy="-2" r="2.1" fill="#fffef2" />
    <circle cx={x + 1.6} cy="4" r="1" fill="#dff2c5" />
  </g>
);
SparklyEye.propTypes = { x: PropTypes.number.isRequired };

const PeaFace = ({ x, y, mood = 'smile', peek = false }) => (
  <g transform={`translate(${x} ${y})`}>
    <circle r="38" fill="#bee88a" stroke="#59854a" strokeWidth="2.5" />
    <path
      d="M-25-12c4-10 12-16 21-16"
      fill="none"
      stroke="#e5f8bd"
      strokeWidth="7"
      strokeLinecap="round"
    />
    <g transform={peek ? 'translate(0 -6)' : undefined}>
      <ellipse cx="-24" cy="13" rx="8.5" ry="5.5" fill="#f3b6b3" />
      <ellipse cx="24" cy="13" rx="8.5" ry="5.5" fill="#f3b6b3" />
      <path
        d="M-27 12l1 3m5-3 1 3M21 12l1 3m5-3 1 3"
        fill="none"
        stroke="#e9979d"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      {mood === 'wink' ? (
        <path
          d="M-19 4q6-7 12 0"
          fill="none"
          stroke="#294d34"
          strokeWidth="3.2"
          strokeLinecap="round"
        />
      ) : (
        <SparklyEye x={-13} />
      )}
      <SparklyEye x={13} />
      {mood === 'wow' ? (
        <ellipse cy="17" rx="4" ry="5" fill="#294d34" />
      ) : (
        <path
          d="M-7 14q3.5 6 7 0q3.5 6 7 0"
          fill="none"
          stroke="#294d34"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </g>
  </g>
);

PeaFace.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  mood: PropTypes.string,
  peek: PropTypes.bool,
};

const PeaCharacter = ({ compact = false, className = '' }) =>
  compact ? (
    <svg className={className} viewBox="0 0 96 108" aria-hidden="true" focusable="false">
      <path d="M48 29C29 25 30 5 31 5c17 0 26 11 17 24Z" fill="#88b95a" />
      <path d="M48 29C46 12 66 8 70 11c-1 13-10 21-22 18Z" fill="#b3db7c" />
      <PeaFace x={48} y={66} mood="wink" />
    </svg>
  ) : (
    <svg
      className={className}
      viewBox="0 0 360 180"
      role="img"
      aria-label="Three little peas peeking out of a pod"
    >
      <ellipse cx="180" cy="152" rx="111" ry="9" fill="#e5edcf" />
      <path
        d="M48 82C98 48 263 48 312 82c-14 40-65 64-132 66C110 148 65 124 48 82Z"
        fill="#86b765"
        stroke="#59854a"
        strokeWidth="3"
      />
      <path
        d="M307 83c29-8 29-31 14-33-14-2-16 12-7 15"
        fill="none"
        stroke="#59854a"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M55 84C35 81 28 63 31 54c19 1 29 13 24 30Z"
        fill="#b3d781"
        stroke="#59854a"
        strokeWidth="2"
      />
      <PeaFace x={110} y={92} peek />
      <PeaFace x={180} y={86} mood="wink" peek />
      <PeaFace x={250} y={92} mood="wow" peek />
      <path
        d="M48 82C72 96 89 104 110 105C134 107 154 104 180 104C207 104 229 107 250 105C277 102 297 91 312 82C300 123 252 147 180 148C108 148 65 124 48 82Z"
        fill="#9dc86e"
        stroke="#59854a"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M69 109C124 152 235 152 292 109"
        fill="none"
        stroke="#d5eaa5"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path d="M60 28c-13-8-15-14-9-17 4-2 7 1 8 4 3-5 8-5 11-2 4 5-1 11-10 15Z" fill="#efb2b7" />
      <path d="M291 35c-10-6-11-11-7-13 3-2 6 0 6 3 3-4 7-4 9-1 3 4-1 8-8 11Z" fill="#f2c3c5" />
      <path d="m326 109 2-6 2 6 6 2-6 2-2 6-2-6-6-2Z" fill="#c4d88c" />
    </svg>
  );

PeaCharacter.propTypes = { compact: PropTypes.bool, className: PropTypes.string };
export default PeaCharacter;
